module.exports = __webpack_public_path__ + "static/media/phone22x.5fd8e519.png";